import React, { useEffect } from 'react';

import { func, number, bool } from 'prop-types';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';

import AppbarLink from 'components/Common/LayoutV2/AppBar/DesktopV2/components/AppbarLink';

import { MESSAGES } from 'routes/constants';

import * as notificationActions from 'modules/Notifications/actions';

const Messages = ({
  unseenMessageCenterCount,
  getUnseenNotificationsCount,
  disabled,
}) => {
  useEffect(() => {
    getUnseenNotificationsCount();
  }, [getUnseenNotificationsCount]);
  return (
    <AppbarLink
      aria-label="View messages"
      icon={faEnvelope}
      href={MESSAGES}
      badgeCount={
        unseenMessageCenterCount > 9 ? '9+' : unseenMessageCenterCount
      }
      disabled={disabled}
    />
  );
};

Messages.propTypes = {
  unseenMessageCenterCount: number,
  disabled: bool,
  getUnseenNotificationsCount: func.isRequired,
};

Messages.defaultProps = {
  disabled: false,
  unseenMessageCenterCount: null,
};

export default connect(
  ({ notifications: { unseenMessageCenterCount } }) => ({
    unseenMessageCenterCount,
  }),
  dispatch => bindActionCreators({ ...notificationActions }, dispatch),
)(Messages);
